import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga";

function AnalyticsListener() {
    const location = useLocation();

    useEffect(() => {
        const page = location.pathname + location.search;
        ReactGA.set({ page }); // Update the user's current page
        ReactGA.pageview(page); // Record a pageview for the given page
    }, [location]);

    return null;
}

export default AnalyticsListener;
